export default __webpack_public_path__ + "dd6fd292973a8a8be8df4edea5f8a41e.png";